.LogoBar {
  position: relative;
  display: block;
  width: 100%;
  height: 4rem;
  overflow-x: hidden;
}

.LogoBarInner {
  position: absolute;
  display: flex;
  flex-flow: row nowrap;
  gap: 3rem;
  margin: 1rem 0;
  animation: slideRight 40s linear infinite;
}

@-webkit-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: -4500px;
  }
}

@keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: -4500px;
  }
}
